import { render, staticRenderFns } from "./OfficeEdit.vue?vue&type=template&id=6de0bf51&scoped=true&"
import script from "./OfficeEdit.vue?vue&type=script&lang=js&"
export * from "./OfficeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0bf51",
  null
  
)

export default component.exports